import { api, unwrap } from './api';
import type { TenantSummary } from './auth';

interface TenantListEnvelope {
  items: BackendTenant[];
}

interface BackendTenant {
  id: string;
  name: string;
  slug: string | null;
  status: string;
}

function normalizeTenant(tenant: BackendTenant): TenantSummary {
  return {
    tenant_id: tenant.id,
    name: tenant.name,
    slug: tenant.slug,
    status: tenant.status,
    is_platform_admin: false,
  };
}

export async function listTenants(): Promise<TenantSummary[]> {
  const data = await unwrap<TenantListEnvelope>(api.get('/tenants'));
  return data.items.map(normalizeTenant);
}

export async function fetchCurrentTenant(): Promise<TenantSummary> {
  const data = await unwrap<BackendTenant>(api.get('/tenants/current'));
  return normalizeTenant(data);
}
